export interface Comic {
  id: number;
  title: string;
  cover: string;
  author: string;
  genre: string;
  tags: string[];
  rating: number;
  status: '连载中' | '已完结';
  chapters: number;
  year: number;
  heat: number;
  description: string;
}

export const genres = [
  '全部',
  '热血',
  '恋爱',
  '玄幻',
  '悬疑',
  '搞笑',
  '日常',
  '科幻',
  '校园',
  '治愈',
  '冒险',
  '战斗',
  '运动',
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '赤焰战纪',
    cover: 'https://readdy.ai/api/search-image?query=Anime%20manga%20cover%20illustration%20of%20a%20young%20hero%20wielding%20a%20flaming%20sword%20against%20a%20dark%20crimson%20sky%2C%20epic%20battle%20scene%2C%20dynamic%20pose%2C%20vibrant%20warm%20orange%20and%20red%20lighting%2C%20high%20detail%20digital%20painting%2C%20comic%20book%20art%20style%20with%20bold%20ink%20lines&width=400&height=560&seq=cover-01&orientation=portrait',
    author: '苍雷工作室',
    genre: '热血',
    tags: ['战斗', '少年', '燃向'],
    rating: 9.2,
    status: '连载中',
    chapters: 248,
    year: 2021,
    heat: 985000,
    description:
      '少年烬天生被封印的赤炎之力一朝觉醒，他踏上对抗深渊种族的征途，与伙伴并肩守护濒临崩溃的世界。热血沸腾的战斗与兄弟情义交织，燃到骨子里的少年漫。',
  },
  {
    id: 2,
    title: '星野恋歌',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20anime%20manga%20cover%20of%20two%20teenagers%20under%20a%20starry%20night%20sky%2C%20soft%20warm%20pink%20and%20golden%20glow%2C%20cherry%20blossoms%20floating%2C%20sweet%20youthful%20mood%2C%20clean%20linework%2C%20shoujo%20comic%20style%2C%20gentle%20lighting&width=400&height=560&seq=cover-02&orientation=portrait',
    author: '知夏',
    genre: '恋爱',
    tags: ['校园', '青春', '甜宠'],
    rating: 8.9,
    status: '已完结',
    chapters: 126,
    year: 2020,
    heat: 762000,
    description:
      '转学生与天文社少年因为一场流星雨意外结缘，两个不善表达的人，在星空下悄悄靠近。细腻的校园恋爱物语，温暖治愈，结局甜度满分。',
  },
  {
    id: 3,
    title: '苍澜御仙',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20xianxia%20anime%20cover%20of%20a%20cultivator%20with%20flowing%20robes%20and%20sword%2C%20misty%20mountains%20and%20waterfall%20background%2C%20teal%20and%20warm%20gold%20accents%2C%20epic%20cultivation%20world%2C%20detailed%20wuxia%20illustration%2C%20dramatic%20lighting&width=400&height=560&seq=cover-03&orientation=portrait',
    author: '墨羽仙',
    genre: '玄幻',
    tags: ['修仙', '冒险', '东方'],
    rating: 9.0,
    status: '连载中',
    chapters: 312,
    year: 2022,
    heat: 1102000,
    description:
      '凡人少年意外获得上古剑诀残卷，从此踏上漫漫修仙路。斩妖除魔、寻仙问道，一路结识知己、解开天地隐秘，描绘波澜壮阔的东方玄幻世界。',
  },
  {
    id: 4,
    title: '迷雾档案',
    cover: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20anime%20cover%20with%20a%20detective%20figure%20holding%20a%20magnifying%20glass%20in%20dense%20fog%2C%20noir%20moody%20atmosphere%2C%20muted%20teal%20and%20gray%20tones%20with%20warm%20amber%20streetlight%2C%20intriguing%20suspense%2C%20detailed%20illustration&width=400&height=560&seq=cover-04&orientation=portrait',
    author: '潜行猫咪',
    genre: '悬疑',
    tags: ['推理', '犯罪', '烧脑'],
    rating: 9.1,
    status: '已完结',
    chapters: 98,
    year: 2019,
    heat: 689000,
    description:
      '每一个看似平常的案件背后都藏着惊人秘密，刑警与神秘档案管理员联手破解一桩桩悬案。环环相扣的推理过程，反转不断，让你欲罢不能。',
  },
  {
    id: 5,
    title: '笑闹天团',
    cover: 'https://readdy.ai/api/search-image?query=Comedy%20anime%20cover%20of%20a%20group%20of%20five%20hilarious%20students%20making%20funny%20faces%2C%20bright%20vibrant%20yellow%20and%20orange%20background%2C%20energetic%20and%20playful%20mood%2C%20cartoonish%20expressive%20style%2C%20chibi%20influenced%2C%20colorful%20and%20lighthearted&width=400&height=560&seq=cover-05&orientation=portrait',
    author: '橘子汽水',
    genre: '搞笑',
    tags: ['校园', '沙雕', '日常'],
    rating: 8.7,
    status: '连载中',
    chapters: 164,
    year: 2021,
    heat: 543000,
    description:
      '校园广播社的五位活宝每天都在上演爆笑日常，从社团活动到日常小事，笑点密集不冷场。压力大的时候点开，保证让你笑出腹肌。',
  },
  {
    id: 6,
    title: '云端料理师',
    cover: 'https://readdy.ai/api/search-image?query=Cooking%20anime%20cover%20with%20a%20chef%20preparing%20steaming%20delicious%20food%20dish%2C%20warm%20golden%20kitchen%20lighting%2C%20appetizing%20gourmet%20food%20illustration%2C%20cozy%20healing%20atmosphere%2C%20detailed%20food%20painting%2C%20soft%20warm%20tones&width=400&height=560&seq=cover-06&orientation=portrait',
    author: '暖勺',
    genre: '治愈',
    tags: ['美食', '暖心', '日常'],
    rating: 8.8,
    status: '已完结',
    chapters: 110,
    year: 2020,
    heat: 598000,
    description:
      '在一间开在云端的小小餐厅里，天才主厨用一道道美食治愈每一位客人的心。关于食物、记忆与和解的温暖故事，每一话都让人馋哭。',
  },
  {
    id: 7,
    title: '机械纪元',
    cover: 'https://readdy.ai/api/search-image?query=Cyberpunk%20sci-fi%20anime%20cover%20with%20a%20cyborg%20warrior%20in%20a%20futuristic%20neon%20city%2C%20mecha%20silhouette%2C%20warm%20orange%20and%20magenta%20neon%20glow%20against%20dark%20tone%2C%20sci-fi%20dystopia%2C%20highly%20detailed%20digital%20art&width=400&height=560&seq=cover-07&orientation=portrait',
    author: '零号机',
    genre: '科幻',
    tags: ['机战', '末世', '热血'],
    rating: 9.3,
    status: '连载中',
    chapters: 201,
    year: 2022,
    heat: 1204000,
    description:
      '在AI统治地球的末世，残存人类驾驶最后一批机甲展开反抗。少年与觉醒自我意识的机体，在废墟中寻找名为“希望”的答案。',
  },
  {
    id: 8,
    title: '盛夏操场',
    cover: 'https://readdy.ai/api/search-image?query=Sports%20anime%20cover%20of%20a%20runner%20on%20a%20sunny%20summer%20track%20field%2C%20sweat%20and%20determination%2C%20bright%20blue%20sky%20with%20warm%20sunlight%2C%20dynamic%20motion%2C%20youthful%20energy%2C%20detailed%20athletic%20illustration%2C%20vivid%20and%20inspiring&width=400&height=560&seq=cover-08&orientation=portrait',
    author: '逆风少年',
    genre: '运动',
    tags: ['青春', '竞技', '田径'],
    rating: 8.9,
    status: '已完结',
    chapters: 88,
    year: 2018,
    heat: 476000,
    description:
      '一支濒临解散的校园田径队，在队长与天才新人的带领下重整旗鼓。汗水、泪水与掌声交织的青春竞技物语，为梦想拼尽全力的模样最动人。',
  },
  {
    id: 9,
    title: '暗夜裁决',
    cover: 'https://readdy.ai/api/search-image?query=Dark%20action%20anime%20cover%20of%20a%20cloaked%20vigilante%20on%20a%20rooftop%20at%20night%20overlooking%20city%20lights%2C%20moody%20warm%20orange%20and%20crimson%20lighting%2C%20noir%20cinematic%20feel%2C%20action%20pose%2C%20detailed%20dark%20illustration&width=400&height=560&seq=cover-09&orientation=portrait',
    author: '夜行灯',
    genre: '动作',
    tags: ['都市', '犯罪', '爽漫'],
    rating: 9.0,
    status: '连载中',
    chapters: 176,
    year: 2021,
    heat: 833000,
    description:
      '白天是普通上班族，夜晚化身游走于法律边缘的“裁决者”。打击黑恶、守护弱者，在正义与规则之间寻找自己的答案，动作戏干脆利落。',
  },
  {
    id: 10,
    title: '灵狐客栈',
    cover: 'https://readdy.ai/api/search-image?query=Cute%20fantasy%20anime%20cover%20with%20a%20nine-tailed%20fox%20spirit%20girl%20in%20a%20traditional%20Chinese%20inn%2C%20warm%20lantern%20glow%2C%20ancient%20style%20architecture%2C%20magical%20cozy%20atmosphere%2C%20soft%20golden%20and%20pink%20tones%2C%20charming%20illustration&width=400&height=560&seq=cover-10&orientation=portrait',
    author: '小狐仙',
    genre: '治愈',
    tags: ['古风', '灵异', '暖心'],
    rating: 8.6,
    status: '连载中',
    chapters: 92,
    year: 2023,
    heat: 421000,
    description:
      '在一座只会在月圆之夜现身的古色客栈里，灵狐掌柜招待各路妖怪与迷途之人。借宿一晚，便可了却一段心愿，温情满满的志怪故事。',
  },
  {
    id: 11,
    title: '次元门扉',
    cover: 'https://readdy.ai/api/search-image?query=Fantasy%20adventure%20anime%20cover%20with%20a%20portal%20gate%20opening%20to%20another%20dimension%2C%20hero%20stepping%20through%2C%20magical%20sparkles%20and%20warm%20light%2C%20colorful%20otherworldly%20landscape%2C%20epic%20adventure%20mood%2C%20detailed%20fantasy%20illustration&width=400&height=560&seq=cover-11&orientation=portrait',
    author: '北纬三十度',
    genre: '冒险',
    tags: ['奇幻', '穿越', '伙伴'],
    rating: 8.8,
    status: '已完结',
    chapters: 143,
    year: 2019,
    heat: 615000,
    description:
      '平凡高中生误触古老门扉，被卷入横跨多个次元的冒险旅程。在异世界结识各色伙伴，一路收集门之碎片，揭开世界交错的宏大真相。',
  },
  {
    id: 12,
    title: '心动便利店',
    cover: 'https://readdy.ai/api/search-image?query=Cute%20romance%20anime%20cover%20with%20a%20convenience%20store%20scene%2C%20a%20shy%20cashier%20and%20a%20regular%20customer%2C%20warm%20soft%20lighting%20at%20night%2C%20sweet%20fluffy%20mood%2C%20pink%20and%20amber%20tones%2C%20charming%20illustration%2C%20cozy%20and%20heartwarming&width=400&height=560&seq=cover-12&orientation=portrait',
    author: '晚风贩卖机',
    genre: '恋爱',
    tags: ['日常', '甜漫', '治愈'],
    rating: 8.7,
    status: '已完结',
    chapters: 76,
    year: 2022,
    heat: 537000,
    description:
      '24小时便利店的夜班店员，与每晚固定光顾的神秘顾客，从一句“欢迎光临”开始的心动故事。平凡日常里的甜，藏在每一次相遇里。',
  },
  {
    id: 13,
    title: '雷霆学院',
    cover: 'https://readdy.ai/api/search-image?query=Academy%20action%20anime%20cover%20of%20students%20with%20electric%20lightning%20powers%20in%20a%20modern%20superpower%20school%2C%20dynamic%20battle%20stance%2C%20vibrant%20yellow%20and%20orange%20energy%2C%20energetic%20and%20heroic%2C%20detailed%20shounen%20style%20illustration&width=400&height=560&seq=cover-13&orientation=portrait',
    author: '闪电组',
    genre: '热血',
    tags: ['超能力', '学院', '群像'],
    rating: 9.1,
    status: '连载中',
    chapters: 189,
    year: 2020,
    heat: 974000,
    description:
      '在这所培养超能力者的雷霆学院里，一群个性迥异的学生为守护和平而战。热血群像、学院日常与燃向战斗兼具，少年漫的青春天花板。',
  },
  {
    id: 14,
    title: '深海回响',
    cover: 'https://readdy.ai/api/search-image?query=Deep%20sea%20mystery%20anime%20cover%20with%20a%20submarine%20and%20giant%20sea%20creature%20silhouette%2C%20dark%20blue%20and%20teal%20ocean%20with%20warm%20bioluminescent%20glow%2C%20suspenseful%20underwater%20atmosphere%2C%20sci-fi%20thriller%2C%20detailed%20moody%20illustration&width=400&height=560&seq=cover-14&orientation=portrait',
    author: '蓝鲸谣',
    genre: '悬疑',
    tags: ['科幻', '深海', '惊悚'],
    rating: 8.9,
    status: '已完结',
    chapters: 84,
    year: 2021,
    heat: 512000,
    description:
      '深海科考队在马里亚纳海沟深处接收到一段未知回响，随之而来的是一连串无法解释的现象。科学与未知的边界，在深渊之下逐渐模糊。',
  },
  {
    id: 15,
    title: '美食大冒险',
    cover: 'https://readdy.ai/api/search-image?query=Food%20adventure%20anime%20cover%20of%20a%20chef%20traveling%20through%20a%20colorful%20fantasy%20land%20collecting%20ingredients%2C%20delicious%20dishes%20flying%20around%2C%20vibrant%20appetizing%20colors%2C%20playful%20gourmet%20mood%2C%20detailed%20food%20fantasy%20illustration&width=400&height=560&seq=cover-15&orientation=portrait',
    author: '锅铲侠',
    genre: '冒险',
    tags: ['美食', '奇幻', '搞笑'],
    rating: 8.6,
    status: '连载中',
    chapters: 121,
    year: 2023,
    heat: 468000,
    description:
      '为寻找传说中的“万味之灵”，天才小厨师踏上遍访世界各地美食的冒险。一路用料理征服人心，也闹出无数笑料，好吃又好玩。',
  },
  {
    id: 16,
    title: '纸间拾光',
    cover: 'https://readdy.ai/api/search-image?query=Artistic%20healing%20anime%20cover%20with%20a%20girl%20reading%20an%20old%20book%20by%20a%20warm%20window%2C%20paper%20texture%20and%20dried%20flowers%2C%20soft%20golden%20afternoon%20light%2C%20nostalgic%20cozy%20mood%2C%20literary%20aesthetic%2C%20gentle%20warm%20tones%2C%20beautiful%20illustration&width=400&height=560&seq=cover-16&orientation=portrait',
    author: '旧时光',
    genre: '治愈',
    tags: ['文艺', '温情', '人生'],
    rating: 8.8,
    status: '已完结',
    chapters: 67,
    year: 2020,
    heat: 429000,
    description:
      '在一家收藏旧书的小书店里，店主与每一位顾客交换着关于时光的故事。翻开纸页，拾起被遗忘的温暖，一部安静而深刻的人生群像。',
  },
];

export const updateFeed = [
  { id: 1, chapter: '第248话', time: '今天 12:30' },
  { id: 3, chapter: '第312话', time: '今天 10:15' },
  { id: 7, chapter: '第201话', time: '昨天 22:40' },
  { id: 9, chapter: '第176话', time: '昨天 20:05' },
  { id: 13, chapter: '第189话', time: '昨天 18:22' },
  { id: 10, chapter: '第92话', time: '昨天 16:48' },
  { id: 15, chapter: '第121话', time: '前天 21:33' },
  { id: 5, chapter: '第164话', time: '前天 19:10' },
];

export const fanGroups = [
  { name: '星火汉化组', focus: '热血·战斗向作品', members: '2.1万', desc: '专注热血战斗向汉化，出品稳定、译名考究。' },
  { name: '拾光汉化组', focus: '治愈·日常向作品', members: '1.4万', desc: '用温柔的翻译还原温暖的故事，精校精修。' },
  { name: '夜航汉化组', focus: '悬疑·推理向作品', members: '9800', desc: '烧脑作品专属，细节控的最爱，校对一丝不苟。' },
  { name: '甜心汉化组', focus: '恋爱·校园向作品', members: '1.7万', desc: '甜漫翻译担当，台词译得甜度拉满。' },
];

export const comicsByGenre = (genre: string) =>
  genre === '全部' ? comics : comics.filter((c) => c.genre === genre || c.tags.includes(genre));